import {ErrorReferential} from "../../interfaces/error/error";

export const VIEW_ERRORS: ErrorReferential = {
    VIEW_NAME_ALREADY_EXISTS: {id: "VIEW_NAME_ALREADY_EXISTS"},
    SV_NAME_IS_REQUIRED: {id: "SV_NAME_IS_REQUIRED"},
    SV_NAME_IS_TOO_SHORT: {id: "SV_NAME_IS_TOO_SHORT"},
    SV_NAME_IS_TOO_LONG: {id: "SV_NAME_IS_TOO_LONG"},
}
